export const storeLastTransactions = (state, lastTransactions) => {
  state.lastTransactions = [...lastTransactions];
};
